<template>
	<div class="inline">
		<el-form-item :label="lab">
			<el-select v-model="val">
				<el-option
					v-for="item in options"
					:key="item.value"
					:label="item.namne"
					:value="item.value">
				</el-option>
			</el-select>
		</el-form-item>
	</div>
</template>
<script>

export default {
	name: 'inputCom',
	props: {
    comObj: {
      type: String,
      default: ''
		},
		lab: {
			type: String,
      default: ''
		}
  },
	data () {
		return {
			// val: '',
			options: [
				{
					name: '入园体检',
					value: '入园体检',
				},
				{
					name: '六一体检',
					value: '六一体检',
				},
				{
					name: '自定义体检',
					value: '自定义体检',
				},
			]
		}
	},
	computed: {
		val: {
			get() {
				return this.comObj
			},
			set(val) {
				this.$emit('update:comObj', val)
			}
		}
	},
	watch: {
		// val(val){
		// 	this.$emit('update:comObj', val)
		// },
	},
	methods: {
	},
	created () {
		this.val = this.comObj
	}
}
</script>



// WEBPACK FOOTER //
// src/components/reports/codeCom/physicalType.vue?59797750